'use client';

import { PageGrid, PageGridItem } from 'corgi/common/components/PageGrid';
import LoginForm from 'corgi/login-form/components/LoginForm';

import { BackToLinkGridItem } from '@components/signup/body/common';
import { commonGridStyles } from '@components/signup/body/styles';
import type { SignupBodyProps } from '@local-types/signup/props';

const LoginBody = ({ loginFormProps, loginBackToLinkProps }: SignupBodyProps) => (
  <PageGrid
    {...commonGridStyles}
    pt={['sp_20', 'sp_24', null, 'sp_32']}
    pb={['sp_20', null, 'sp_24', 'sp_32']}
    flexDirection={['column', null, 'row']}
    alignItems={['center', null, 'flex-start']}
    justifyContent={['flex-start', null, 'center']}
    alignContent={[null, null, 'flex-start']}
  >
    <PageGridItem width={[1, 3 / 4, '400px', '448px']} maxWidth={['432px', null, '448px']}>
      {loginFormProps && <LoginForm {...loginFormProps} />}
    </PageGridItem>

    <BackToLinkGridItem
      loginBackToLinkProps={loginBackToLinkProps}
      styles={{ mt: ['sp_20', 'sp_24', null, 'sp_32'] }}
    />
  </PageGrid>
);

export default LoginBody;
